export var ErrorType = /*#__PURE__*/function (ErrorType) {
  ErrorType["SERVER"] = "server";
  ErrorType["AUTHORIZATION"] = "auth";
  ErrorType["INLINE"] = "inline";
  return ErrorType;
}({});
export var InlineError = /*#__PURE__*/function (InlineError) {
  InlineError["REQUIRED"] = "required";
  InlineError["INVALID"] = "invalid";
  return InlineError;
}({});

//unfortunately, we need to break convention here because code and message are defined as lower-case in
//redux interfaces.
export var ADDRESS_VALIDATION_ERRORS = {
  MISSING_PARAMS: {
    code: 'ADDR-100',
    type: ErrorType.SERVER,
    message: 'zipcode or country code not passed'
  },
  INCORRECT_COUNTRY_CODE: {
    code: 'ADDR-101',
    type: ErrorType.SERVER,
    message: 'incorrect country code format passed'
  },
  SMARTY_STREETS_API_ERROR: {
    code: 'ADDR-102',
    type: ErrorType.SERVER,
    message: 'API endpoint error. See message for details'
  },
  UNKNOWN_ERROR: {
    code: 'ADDR-103',
    type: ErrorType.SERVER,
    message: 'unknown error occurred'
  },
  ZIPCODE_NOT_FOUND: {
    code: 'ADDR-104',
    type: ErrorType.SERVER,
    message: 'invalid zipcode'
  },
  SMARTY_STREETS_KEYS_ERROR: {
    code: 'ADDR-105',
    type: ErrorType.SERVER,
    message: 'Error Fetching API Key AWS Secrets for Smarty Streets.'
  }
};
export var API_FAILURE_ERRORS = /*#__PURE__*/function (API_FAILURE_ERRORS) {
  API_FAILURE_ERRORS["API_FAILURE"] = "API-001";
  return API_FAILURE_ERRORS;
}({});
export var AUTH_FAILURE_ERRORS = /*#__PURE__*/function (AUTH_FAILURE_ERRORS) {
  AUTH_FAILURE_ERRORS["AUTH_FAILURE"] = "CSDK-002";
  return AUTH_FAILURE_ERRORS;
}({});
export var ERRORS = {
  INLINE_ERRORS: {
    code: 'UA-201',
    message: 'Form contains inline errors',
    type: ErrorType.INLINE
  },
  UNSUPPORTED_COMMAND: {
    code: 'UA-202',
    message: 'Unsupported Command',
    type: ErrorType.SERVER
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/user-address/dist/esm/constants/Errors.js
// module id = 390
// module chunks = 11